import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";

import PropTypes from "prop-types";

import leftArrow from "../images/chevron-left.svg";
import rightArrow from "../images/chevron-right.svg";
import firebase from "../config/firebase";

// import './third.css'
var db = firebase.database();

class FirstSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arr: [],
    };
  }
  componentDidMount() {
    this.getData();
  }

  getData = () => {
    db.ref("clientData").on("value", (snapshot) => {
      var newArr = [];
      snapshot.forEach((data) => {
        var childData = data.val();

        newArr.push(childData);
      });
      this.setState({ arr: newArr.reverse() });
    });
  };
  render() {
    return (
      <div class="container-fluid">
        <section class="py-5">
          <div class="container text-center">
            <h1
              className="text-center"
              style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
            >
              <i class="fa fa-users"></i> VALUABLE CLIENTS
            </h1>
            <p class="lead">
              we’ve had the pleasure of working with our valuable clients
            </p>
            <div class="row">
              <div
                class="carousel slide my-4"
                id="carousel-testimonials-02"
                data-ride="carousel"
              >
                <div class="carousel-inner">
                  {this.state.arr.map((e, i) => {
                    return (
                      <div
                        class={
                          i === 0 ? "carousel-item active" : "carousel-item"
                        }
                        key={i}
                      >
                        <div class="row align-items-center  ">
                          <div class="col-md-6">
                            <img class="img-fluid" src={e.downloadURL} alt="" />
                          </div>
                          <div class="col-md-6 mb-4 mb-md-0">
                            <span
                              class="display-3 mb-2"
                              style={{ color: "rgb(118, 102, 223)" }}
                            >
                              {e.headingName}
                            </span>

                            <h4 class="mb-4">
                              {e.buttonLink}
                              {e.clientWebsite === "#" ? (
                                ""
                              ) : (
                                <a
                                  rel="noopener noreferrer"
                                  href={`//${e.clientWebsite}`}
                                  target="_blank"
                                  class="ml-2"
                                >
                                  <i
                                    style={{ color: "rgb(118, 102, 223)" }}
                                    class="fas fa-external-link-square-alt"
                                  ></i>
                                </a>
                              )}
                            </h4>

                            <h5> {e.githubLink}</h5>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* <div class="carousel-item ">
                    <div class="row align-items-center text-md-left mb-5">
                      <div class="col-md-6 order-1 order-md-0">
                        <img class="img-fluid" src={upnmImage} alt="" />
                      </div>
                      <div class="col-md-6 mb-4 mb-md-0">
                        <span
                          class="display-4 mb-2"
                          style={{ color: "rgb(118, 102, 223)" }}
                        >
                          kafeupnm
                        </span>
                        <h4 class="mb-4">Food Delivery Web App (PWA)</h4>
                        <h5>
                          kafeupnm is a Food Delivery App like Uber Eats, Food
                          Panda.
                        </h5>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div class="mx-auto">
                <a
                  class="carousel-control-prev position-relative d-inline mr-2"
                  href="#carousel-testimonials-02"
                  role="button"
                  data-slide="prev"
                >
                  <img src={leftArrow} aria-hidden="true" alt="" />
                  <span class="sr-only">Previous</span>
                </a>
                <a
                  class="carousel-control-next position-relative d-inline"
                  href="#carousel-testimonials-02"
                  role="button"
                  data-slide="next"
                >
                  <img src={rightArrow} aria-hidden="true" alt="" />
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>
            <div>
              {/* <div class="row align-items-center text-md-left mb-5">
              <div class="col-md-6 order-1 order-md-0">
                <img
                  class="img-fluid"
                  src="https://new.shuffle.dev/placeholder/pictures/bg_16-9.svg?primary=007bff"
                  alt=""
                />
              </div>
              <div class="col-md-6 mb-4 mb-md-0">
                <span class="display-3 mb-2">03</span>
                <h3 class="mb-4">Ongoing Support</h3>
                <p>
                  As with all innovative technologies, sometimes unpredictable
                  things will happen, and you can always count on our support to
                  solve issues for you.
                </p>
              </div>
            </div> */}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
// }

FirstSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(FirstSection);
